// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2yIMi","rootSuccess":"CompleteLink_rootSuccess__ABY0I","rootFailure":"CompleteLink_rootFailure__21p9W","isDisabled":"CompleteLink_isDisabled__2-4Nf"};